import SEO from '@/components/SEO';
import { UnifiedProfessionalDirectory } from '@/components/UnifiedProfessionalDirectory';

export default function OTDirectory() {
  return (
    <>
      <SEO
        title="Occupational Therapists Directory"
        description="Find occupational therapists in the SeniorThrive network. Browse specialists, service areas, and contact details."
        keywords="occupational therapist, OT, therapy, rehabilitation, aging in place, therapist directory"
        canonical="https://seniorthrive.com/occupational-therapists/directory"
      />
      
      <UnifiedProfessionalDirectory 
        professionType="OT"
        title="Occupational Therapists Directory"
        description="Browse occupational therapists in the SeniorThrive network."
      />
    </>
  );
}